// src/signals/customer-travel-advisory-hide-signal.ts
function _assert_this_initialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _class_call_check(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _get_prototype_of(o) {
  _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
  if (call && (_type_of(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
  _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _set_prototype_of(o, p);
}
function _type_of(obj) {
  "@swc/helpers - typeof";

  return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _create_super(Derived) {
  var hasNativeReflectConstruct = _is_native_reflect_construct();
  return function _createSuperInternal() {
    var Super = _get_prototype_of(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _get_prototype_of(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possible_constructor_return(this, result);
  };
}
import { Signal } from "@shared-ui/core-signal-manager/spi";
var CustomerTravelAdvisoryHideSignal = /*#__PURE__*/function (Signal) {
  "use strict";

  _inherits(CustomerTravelAdvisoryHideSignal, Signal);
  var _super = _create_super(CustomerTravelAdvisoryHideSignal);
  function CustomerTravelAdvisoryHideSignal() {
    _class_call_check(this, CustomerTravelAdvisoryHideSignal);
    return _super.apply(this, arguments);
  }
  return CustomerTravelAdvisoryHideSignal;
}(Signal);
// src/signals/customer-error-message-clear-error-message-signal.ts
import { Signal as Signal2 } from "@shared-ui/core-signal-manager/spi";
var CustomerErrorMessageClearErrorMessageSignal = /*#__PURE__*/function (Signal2) {
  "use strict";

  _inherits(CustomerErrorMessageClearErrorMessageSignal, Signal2);
  var _super = _create_super(CustomerErrorMessageClearErrorMessageSignal);
  function CustomerErrorMessageClearErrorMessageSignal() {
    _class_call_check(this, CustomerErrorMessageClearErrorMessageSignal);
    return _super.apply(this, arguments);
  }
  return CustomerErrorMessageClearErrorMessageSignal;
}(Signal2);
// src/signals/customer-error-message-display-signal.ts
import { Signal as Signal3 } from "@shared-ui/core-signal-manager/spi";
var CustomerErrorMessageDisplaySignal = /*#__PURE__*/function (Signal3) {
  "use strict";

  _inherits(CustomerErrorMessageDisplaySignal, Signal3);
  var _super = _create_super(CustomerErrorMessageDisplaySignal);
  function CustomerErrorMessageDisplaySignal() {
    _class_call_check(this, CustomerErrorMessageDisplaySignal);
    return _super.apply(this, arguments);
  }
  return CustomerErrorMessageDisplaySignal;
}(Signal3);
// src/signals/customer-error-message-scroll-page-request-signal.ts
import { Signal as Signal4 } from "@shared-ui/core-signal-manager/spi";
var CustomerErrorMessageScrollPageRequestSignal = /*#__PURE__*/function (Signal4) {
  "use strict";

  _inherits(CustomerErrorMessageScrollPageRequestSignal, Signal4);
  var _super = _create_super(CustomerErrorMessageScrollPageRequestSignal);
  function CustomerErrorMessageScrollPageRequestSignal() {
    _class_call_check(this, CustomerErrorMessageScrollPageRequestSignal);
    return _super.apply(this, arguments);
  }
  return CustomerErrorMessageScrollPageRequestSignal;
}(Signal4);
export { CustomerErrorMessageClearErrorMessageSignal, CustomerErrorMessageDisplaySignal, CustomerErrorMessageScrollPageRequestSignal, CustomerTravelAdvisoryHideSignal };